module.exports = __webpack_public_path__ + "static/media/wind_power_middle_east_desktop.87b800df.jpg";